import { ApiState } from '../../common/constants/api-constants';
import { CreateCustomProductMetadata } from '../create-custom/interfaces/create-custom-product.interface';
import { FreeTrialInfo } from '../free-trial/interfaces/free-trial-info.interface';
import { ReturnInfo } from '../return/interfaces/return-info.interface';
import { RmsBookstoreAddress } from '../checkout/shop-checkout.interface';

export declare interface OrderHistory {
  webOrderNo: string;
  orderId: number;
  orderType?: string;
  userId?: number;
  tax: number;
  freightCharges: number;
  freightType?: string;
  totalPrice: number;
  subTotal: number;
  bundleDiscount?: number;
  orderedDate: string;
  overAllOrderStatus: OrderStatus;
  address: Array<AddressBook>;
  userOrderDetails: Array<UserOrderDetails>;
  totalPromoDiscount: number;
  country: string;
  currencyCode: string;
  orderSegment: string;
  digitalHandlingFees: number;
  paymentAdditionalInfo: { [key: string]: string };
  paymentType: string;
  formatDescription?: string;
  paypalTransactionId?: string;
  purchaseOrderNumber?: string;
  orderStatusText: string;
  totalLineItems: number;
  totalProductCount: number;
  billingAddress?: AddressBook;
  shippingAddress?: AddressBook;
  returnInfo?: ReturnInfo;
  metaOfferId?: string;
  totalRefunded: number;
  couponCode?: string;
  fundingSource?: string;
}

export declare interface OrderHistoryState extends ApiState {
  data: OrderHistory[] | undefined;
}

export enum OrderStatus {
  ORDER_STATUS_SUCCESS = "SUCCESS",
  ORDER_SHIPPED = "SHIPPED",
  ORDER_INPROCESS = "INPROCESS",
  ORDER_COMPLETE = "COMPLETED",
  ORDER_CANCELLED = "CANCELLED",
  ORDER_APPROVED = "APPROVED",
  ORDER_BACKORDERED = "BACKORDERED",
  ORDER_SUBMITTED = "SUBMITTED",
  ORDER_DETAIL_COMPLETE = "complete",
  ORDER_DENIED = "DENIED"
}

export interface AddressBook extends RmsBookstoreAddress {
  type: number;
  street1: string;
  phone: string;
  nickName?: string;
}

export enum AddressType {
  BILLING_ADDRESS = 1,
  SHIPPING_ADDRESS = 2
}

export enum ProductType {
  VIRTUAL_EBOOK = "EBOOK",
  VIRTUAL_ACCESSCODE = "ACCESS_CODE",
  ACCESSCODE_CONSUMED = "CODE_CONSUMED",
  ACCESSCODE_WEBORDER_PREFIX = "CODE_",
  UPSELL_LOOSELEAF_OFFER_TYPE = "LOOSELEAF",
  SHIPPABLE = "SHIPPABLE",
}

export interface UserOrderDetails {
  application?: string;
  productType: ProductType;
  lineItemNumber: number;
  productIsbn: string;
  itemQuantity: number;
  productDescription: string;
  price: number;
  originalPrice: number;
  isDiscountedBundle: boolean;
  accessCode: string;
  lineStatus: OrderStatus;
  createTime: string;
  processedQty: number;
  emailSent: number;
  edition: string;
  editionOrRelease?: string;
  formatCode: string;
  formatDescription: string;
  formatTypeDescription?: string;
  authors: string;
  publicationDate: string;
  isbn10: string;
  isbn13: string;
  source: string;
  coverImage: string;
  grades?: string;
  virtual: boolean;
  productBrandingCode: string;
  mghControlledProduct: boolean;
  available: boolean;
  displayCode: boolean;
  offerId: number;
  offerPolicy: string;
  promoDiscountValue: number;
  promoDiscount: number;
  mhid: string;
  productSegment: string;
  copyrightYear: number;
  entOfferId: number;
  remainingDays: number;
  lineItemStatus: LineItemStatus;
  terms: string;
  isEvergreen?: boolean;
  offerType?: string;
  itemType?: string;
  flow?: string;
  launchObject?: {
    url: string;
    params: Array<any>;
    method: string;
  };
  programSourceId?: string;
  programSourceName?: string;
  freeTrialInfo?: FreeTrialInfo;
  isConnectSharpenBundle?: boolean;
  isSharpenCompanion?: boolean;
  isSharpenAdvantage?: boolean;
  licenseStartDate?: string;
  licenseEndDate?: string;
  boardsBeyondUrl?: string;
  extension_attributes?: Record<string, any>;
  amountRefunded: number;
  businessUnit?: string;
  duration?: number;
  durationPeriod?: string;
  createCustomProductMetadata?: CreateCustomProductMetadata;
}

export enum LineItemStatus {
  SHIPPED = "shipped",
  PROCESSING = "processing",
  CANCELLED = "cancelled",
  COMPLETE = "complete",
  BACKORDERED = "backordered",
  DENIED = "denied",
  APPROVED = "approved",
  SUBMITTED = "submitted"
}
